/**
 * fuk-walk-gift.js  –  Fuchs & Kiwi (Horizon 3.2.1)
 *
 * Walkaktion: Liegt ein Artikel mit dem Tag "Walkaktionsrabatt" im Warenkorb,
 * wird automatisch 1 Wunderbürste hinzugefügt. Der Preis 0 € kommt weiterhin
 * vom automatischen Shopify-Rabatt "Kaufe X, erhalte Y" – dieses Skript legt
 * die Bürste nur in den Warenkorb bzw. nimmt sie wieder heraus.
 *
 * - Die auto-hinzugefügte Bürste trägt die versteckte Eigenschaft
 *   "_walkaktion_gratis" (Unterstrich = im Checkout nicht sichtbar).
 * - Kein berechtigter Artikel mehr im Warenkorb -> auto-Bürste wird entfernt
 *   (sonst zahlt der Kunde unbemerkt 17,65 €). Selbst gekaufte Bürsten
 *   (ohne Eigenschaft) werden nie angefasst.
 * - Entfernt der Kunde die Gratis-Bürste bewusst, wird sie in dieser
 *   Sitzung nicht erneut hinzugefügt.
 *
 * Aktion beenden: AKTIV auf false setzen (oder Script-Tag entfernen).
 */
(() => {
  if (window.__fukWalkGift) return;
  window.__fukWalkGift = true;

  const AKTIV = false;
  const AKTION_TAG = 'walkaktionsrabatt';         // Vergleich ohne Groß/Klein
  const BUERSTE_VARIANT_ID = 53524653080909;       // Wunderbürste - Reinigungsbürste Walk
  const BUERSTE_PRODUCT_ID = 10576498950477;
  const PROP = '_walkaktion_gratis';
  const SOURCE = 'fuk-walk-gift';
  const SS_ADDED = 'fukWalkGiftAdded';
  const SS_DECLINED = 'fukWalkGiftDeclined';

  if (!AKTIV) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ss = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: (k) => { try { sessionStorage.removeItem(k); } catch (e) {} },
  };

  // Tags je Produkt-Handle (Cache pro Seitenaufruf)
  const tagCache = new Map();
  async function isEligible(item) {
    if (item.product_id === BUERSTE_PRODUCT_ID) return false;
    if (!tagCache.has(item.handle)) {
      tagCache.set(item.handle, fetch(`${root}products/${item.handle}.js`)
        .then((r) => (r.ok ? r.json() : { tags: [] }))
        .then((p) => (p.tags || []).some((t) => String(t).toLowerCase() === AKTION_TAG))
        .catch(() => false));
    }
    return tagCache.get(item.handle);
  }

  async function getCart() {
    const r = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }

  function notifyTheme(cart) {
    // Horizon-Komponenten (Drawer, Zähler) hören auf "cart:update"
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: SOURCE,
        data: { itemCount: cart.item_count, source: SOURCE },
      },
    }));
  }

  let running = false;
  let again = false;

  async function sync() {
    if (running) { again = true; return; }
    running = true;
    try {
      const cart = await getCart();
      const flags = await Promise.all(cart.items.map(isEligible));
      const eligible = flags.some(Boolean);
      const autoLines = cart.items.filter(
        (i) => i.variant_id === BUERSTE_VARIANT_ID && i.properties && i.properties[PROP]
      );
      const hasAnyBrush = cart.items.some((i) => i.variant_id === BUERSTE_VARIANT_ID);

      if (!eligible) {
        ss.del(SS_DECLINED);
        ss.del(SS_ADDED);
        if (autoLines.length) {
          const updates = {};
          autoLines.forEach((l) => { updates[l.key] = 0; });
          const r = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          });
          if (r.ok) notifyTheme(await r.json());
        }
        return;
      }

      // berechtigt
      if (hasAnyBrush) return;                       // schon drin (auto oder selbst gelegt)
      if (ss.get(SS_ADDED)) { ss.set(SS_DECLINED, '1'); return; } // Kunde hat sie entfernt
      if (ss.get(SS_DECLINED)) return;

      const r = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: BUERSTE_VARIANT_ID, quantity: 1, properties: { [PROP]: '1' } }] }),
      });
      if (r.ok) {
        ss.set(SS_ADDED, '1');
        notifyTheme(await getCart());
      }
    } catch (e) {
      console.warn('[fuk-walk-gift]', e);
    } finally {
      running = false;
      if (again) { again = false; sync(); }
    }
  }

  let t;
  const schedule = (delay = 250) => { clearTimeout(t); t = setTimeout(sync, delay); };

  document.addEventListener('cart:update', (e) => {
    const src = e.detail && (e.detail.sourceId || (e.detail.data && e.detail.data.source));
    if (src === SOURCE) return;                      // eigene Events ignorieren
    schedule();
    setTimeout(() => schedule(0), 1500);             // Easify rendert verzögert nach
  });

  // Beim Laden einmal abgleichen (z. B. Warenkorbseite, Rückkehr aus Checkout)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(0));
  } else {
    schedule(0);
  }
})();
